export const globalStateState = {
  // Linguagens
  linguagens: [],
};
